import styled from "styled-components";

export const ChartsGrid = styled.section`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 16px;

  @media (max-width: 767px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const ChartPanel = styled.section`
  min-width: 0;
  overflow: hidden;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
`;

export const ChartHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 38px;
  padding: 8px 12px;
  border-bottom: 1px solid #eef1f4;
  background: #ffffff;
`;

export const ChartTitle = styled.h3`
  margin: 0;
  color: #396598;
  font-size: 14px;
  font-weight: 700;
`;

export const ChartCanvas = styled.div`
  width: 100%;
  height: 258px;
  padding: 4px;
`;

export const ChartEmpty = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #8a94a3;
  font-size: 12px;
`;
